import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import withPagination, { PaginationProps } from "app/utils/withPagination";
import ConfigurableTable from "app/components/AppComponents/ConfigurableTable";
import statusMessageColumns from "./statusMessageColumns";

type Props = {
  name: string;
  order_by_category: boolean;
  filter_by_category: string;
  data?: any;
};

const query = gql`
  query AllStatusMessages(
    $order_by_category: Boolean
    $filter_by_category: String
    $offset: Int
    $limit: Int
  ) {
    status_messages(
      order_by_category: $order_by_category
      filter_by_category: $filter_by_category
      offset: $offset
      limit: $limit
    ) {
      id
      created_at
      category
      level
      message_body
    }
  }
`;

const withData = graphql<any, Props & PaginationProps>(query, {
  options: ({
    order_by_category,
    filter_by_category,
    pagination: { offset, limit },
  }) => ({
    fetchPolicy: "network-only",
    variables: {
      order_by_category,
      filter_by_category,
      offset,
      limit,
    },
  }),
});

export default withPagination(
  withData((props) => (
    <BOGraphQLLoader data={props.data}>
      <ConfigurableTable
        columnConfigs={statusMessageColumns}
        defaultColumns={[
          "Category",
          "Level",
          "Message body",
          "Activate",
          "Edit",
          "Delete",
        ]}
        rows={props.data.status_messages || []}
        pagination={props.pagination}
        name={"Status messages"}
      />
    </BOGraphQLLoader>
  ))
);
